import React, { useState } from "react"
import PropTypes from "prop-types"
import moment from "moment"
import { connect } from 'react-redux'
import { createPlugin } from '@fullcalendar/core'

import LocationTables from "./location-tables"
import GameModal from '../../containers/game-modal'
import OpenGameModal from '../../containers/open-game-modal'
import FacilityOpenGameModal from '../../containers/facility-open-game-modal'
import NewGameForm from '../new-game-form'
import OpenGameForm from '../open-game-form'

const DateTables = ({date, index, locations, isSdAdmin, onEventClicked, onNewEvent}) => {
  const isMultiLocation = locations.length > 1
  const humanizedDate = moment(date).format('dddd, MMMM D, YYYY')
  const dateHeader = isMultiLocation && index !== 0 && <h2 key={`h${date}`}>{humanizedDate}</h2>
  const sectionHeader = !isMultiLocation && index !== 0 ? humanizedDate : null
  let style = {}
  if (!isMultiLocation) {
    if (index === 0) {
      style.marginBottom = "46px"
    } else {
      style.marginTop = "40px"
    }
  }
  const content = (
    <div style={style} key={date}>
      {locations.map((location, i) =>
        <LocationTables
          key={location.id}
          isMultiLocation={isMultiLocation}
          dateIndex={index}
          date={date}
          index={i}
          header={sectionHeader}
          location={location}
          isSdAdmin={isSdAdmin}
          onEventClicked={onEventClicked}
          onNewEvent={onNewEvent}
        />
      )}
    </div>
  )
  return [dateHeader, content]
}

const AltReservationView = props => {
  const [showGame, setShowGame] = useState(false)
  const [showOpenGame, setShowOpenGame] = useState(false)
  const [showFacilityOpenGame, setShowFacilityOpenGame] = useState(false)
  const [showGameForm, setShowGameForm] = useState(null)
  const [showOpenGameForm, setShowOpenGameForm] = useState(false)

  const eventClicked = (event) => {
    if (!event.open) return setShowGame(event.id)

    props.isSdAdmin ? setShowOpenGame(event.id) : setShowFacilityOpenGame(event.id)
  }

  const newEvent = (data) => {
    const params = { 
      date: moment(data.time).subtract({ hours: 6 }).format('MM/DD/YYYY'),
      field: data.field,
      default_time: data.time
    }
    props.sdAdminLevel ? setShowOpenGameForm({type: 'new', params: params}) : setShowGameForm(params)
  }

  const duplicateGame = (id) => {
    setShowOpenGame(false)
    setShowOpenGameForm({type: 'duplicate', id: id})
  }

  const updateOpenGame = (data) => {
    setShowOpenGameForm(false)
    App.store.dispatch({type: 'OPEN_GAME_MODAL.REFRESH_GAME', payload: data})
  }

  return (
    <div className='locations-wrapper component-container'>
      { showGame &&
        <GameModal
          gameId={showGame}
          socketUrl={props.socketUrl}
          onClose={() => setShowGame(false)}
        /> 
      }
      { showOpenGame &&
        <OpenGameModal
          activeTab='game-details'
          gameId={showOpenGame}
          socketUrl={props.socketUrl}
          onClose={() => setShowOpenGame(null)}
          onDuplicate={duplicateGame}
          onEdit={(data) => setShowOpenGameForm(data) }
          onCancel={() => setShowOpenGame(null)}
        /> 
      }
      { showFacilityOpenGame &&
        <FacilityOpenGameModal
          gameId={showFacilityOpenGame}
          socketUrl={props.socketUrl}
          onClose={() => setShowFacilityOpenGame(null)}
        /> 
      }
      { showGameForm &&
        <NewGameForm
          params={showGameForm}
          onClose={() => setShowGameForm(null)}
          sdAdminLevel={props.isSdAdmin}
        /> 
      }
      { showOpenGameForm &&
        <OpenGameForm
          type={showOpenGameForm.type} 
          id={showOpenGameForm.id} 
          recurringId={showOpenGameForm.recurringId}
          params={showOpenGameForm.params}
          onClose={() => setShowOpenGameForm(false)}
          onUpdate={updateOpenGame}
        /> 
      }
      <div>
        {props.datesWithLocations.map(({date, locations}, index) =>
          <DateTables
            key={date}
            date={date}
            index={index}
            locations={locations}
            isSdAdmin={props.isSdAdmin}
            onEventClicked={eventClicked}
            onNewEvent={newEvent}
          />
        )}
      </div>
    </div>
  )
}

const mapStateToProps = ({altReservationView: {datesWithLocations, isSdAdmin, socketUrl}}) => ({
  datesWithLocations, 
  isSdAdmin,
  socketUrl
})

AltReservationView.propTypes = {
  datesWithLocations: PropTypes.array.isRequired,
  isSdAdmin: PropTypes.bool.isRequired,
  socketUrl: PropTypes.string.isRequired
}

export default createPlugin({
  views: {
    Alt: connect(mapStateToProps)(AltReservationView)
  }
})
